import { createGlobalStyle } from 'styled-components';
import 'normalize.css';

import '/shared/fonts/BpSans/stylesheet-test.css';
import { getColourVariables } from '/shared/styled/Colours';

import './GlobalStyleTestInjection.css';

export default createGlobalStyle`
  :root {
    ${({ theme }) => getColourVariables(theme)}
  }
`;
